var docMapConfig = {
    "0": {
        "groupName": "All",
        "docTypeNo": 0,
        "RedirectTo2": false,
        "attributes": [
          {
              "key": "Number",
              "value": "Number",
              "dValue": "DocumentNumber"
          },
          {
              "key": "CreatedBy",
              "value": "DocumentDetails.CreatedByName",
              "dValue": "CreatedByName"
          },
          {
              "key": "CreatedOn",
              "value": "DocumentDetails.CreatedOn",
              "dataType": "Date",
              "dValue": "CreatedOn"
          },
          {
              "key": "TotalValue",
              "value": "DocumentSearchOutput.DocumentAdditionalFieldList~TotalValue+DocumentSearchOutput.DocumentAdditionalFieldList~TotalValueCurrencyCode",
              "dValue": "DocumentAdditionalFieldList~TotalValue+DocumentAdditionalFieldList~TotalValueCurrencyCode"
          }
        ]
    },
    "1": {
        "groupName": "RFX",
        "docTypeNo": 1,
        "RedirectTo2": true,
        "url": "/Sourcing/Rfx?oloc=219&dd=[dd]",
        "oloc": 103,
        "queryStringKey": "rfxQueryString",
        "AttachmentId": "DocumentSearchOutput.DocumentAdditionalFieldList~EventSummaryAttachmentId",
        "attributes": [
          {
              "key": "contact",
              "value": "DocumentSearchOutput.DocumentAdditionalFieldList~EventAuthor"
          },
          {
              "key": "email",
              "value": "DocumentSearchOutput.DocumentAdditionalFieldList~EmailID"
          },
          {
              "key": "start",
              "value": "DocumentSearchOutput.DocumentAdditionalFieldList~Start",
              "dataType": "DateTime"
          },
          {
              "key": "end",
              "value": "DocumentSearchOutput.DocumentAdditionalFieldList~End",
              "dataType": "DateTime"
          },
          {
              "key" : "Category",
               "value" : "DocumentSearchOutput.DocumentAdditionalFieldList~EventPas"
          }
        ]
    }
}
var filterConfig = [
    { "FilterId": 1, "SearchField": "SRCG_EventType", "Value": "RFx Type", "LoadType": "Full", "LoaderKey": "", "ParentLoaderKey": "", "ResponseKeyProp": "", "ResponseLabelProp": "", "ResponseContainer": "", "DocTypeCode": 1, "DocTypeName": "RFx", "IsBuyerVisible": true, "Order": 1, "TreeType": "", "Type": "AutoSuggest", "ACType": "", "ParentFilterId": 0, "ParentDataId": 0, "ParentForDataCascading": 0, "IsCustAttr": false, "IsSupplierVisible": false, "IsTemplateVisible": false, "ASUrl": null, "ASList": [{ "code": "1", "label": "RFP", "IsDefault": false }, { "code": "2", "label": "RFQ", "IsDefault": false }, { "code": "3", "label": "RFI", "IsDefault": false }], "advancedDateRangeFilter": null },
    { "FilterId": 2, "SearchField": "DM_Region", "Value": "Region", "LoadType": "", "LoaderKey": "", "ParentLoaderKey": "", "ResponseKeyProp": "", "ResponseLabelProp": "", "ResponseContainer": "", "DocTypeCode": 1, "DocTypeName": "RFx", "IsBuyerVisible": true, "Order": 2, "TreeType": "REGION", "Type": "Tree", "ACType": "r", "ParentFilterId": 0, "ParentDataId": 0, "ParentForDataCascading": 0, "IsCustAttr": false, "IsSupplierVisible": false, "IsTemplateVisible": true, "ASUrl": "/Controls/TreeView/GetRegionDetails?oloc=102&bpc=[bpc]", "ASList": [], "advancedDateRangeFilter": null },
    { "FilterId": 3, "SearchField": "SRCG_ResponseStart", "Value": "Response Status", "LoadType": "Full", "LoaderKey": "", "ParentLoaderKey": "", "ResponseKeyProp": "", "ResponseLabelProp": "", "ResponseContainer": "", "DocTypeCode": 1, "DocTypeName": "RFx", "IsBuyerVisible": true, "Order": 3, "TreeType": "", "Type": "Dropdown", "ACType": "", "ParentFilterId": 0, "ParentDataId": 0, "ParentForDataCascading": 0, "IsCustAttr": false, "IsSupplierVisible": false, "IsTemplateVisible": false, "ASUrl": null, "ASList": [{ "code": "1", "label": "Response Started", "IsDefault": false }, { "code": "2", "label": "Response Not Started", "IsDefault": false }], "advancedDateRangeFilter": null },
    { "FilterId": 4, "SearchField": "DM_CategoryNew", "Value": "Category", "LoadType": "", "LoaderKey": "", "ParentLoaderKey": "", "ResponseKeyProp": "", "ResponseLabelProp": "", "ResponseContainer": "", "DocTypeCode": 1, "DocTypeName": "RFx", "IsBuyerVisible": true, "Order": 4, "TreeType": "CATEGORY", "Type": "Tree", "ACType": "r", "ParentFilterId": 0, "ParentDataId": 0, "ParentForDataCascading": 0, "IsCustAttr": false, "IsSupplierVisible": false, "IsTemplateVisible": true, "ASUrl": "/Controls/TreeView/GetPASDetails?oloc=102&bpc=[bpc]", "ASList": [], "advancedDateRangeFilter": null }
]
